<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-07-26 10:50:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-11 12:22:14
 * @FilePath: /chaoyongtuan/src/views/shopManage/tobeClaimed/list/components/audit.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-dialog :title="title" :visible.sync="visible" width="500px" @close="handleClose">
			<div class="yx-color-text-primary mb-20 fz-16 ml-10">
				<span v-html="contnet"></span>
			</div>
			<el-form :model="disFrom" ref="disFrom" v-if="showDisFrom">
				<el-form-item :label="zsName" label-width="80px" prop="user_id">
					<zs-partner-select style="width: 240px" v-model="disFrom.user_id" :apiType="1"></zs-partner-select>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="visible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确认审核</el-button>
			</span>
		</el-dialog>
		<loading-dialog ref="loadingDialogRef" @close="handleLoadingClose" message="处理中"></loading-dialog>
		<audit-result-dialog ref="auditResultDialogRef" :auditResult="auditResult"></audit-result-dialog>
	</div>
</template>
 <script>
import { ksActivityAudit, auditActivity, dyActivityAuditBatch, ksActivityBatchAudit } from '@/api/secondColonelManage';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { zsRoleType } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
import LoadingDialog from '@/components/ui/loadingDialog';
import AuditResultDialog from './auditResultDialog';
import { getAuditConfig } from '@/api/settings.js';
export default {
	components: {
		ZsPartnerSelect,
		LoadingDialog,
		AuditResultDialog,
	},
	data() {
		return {
			visible: false,
			isBatch: false,
			title: '提示',
			params: [],
			disFrom: {
				user_id: '',
			},
			contnet: '',
			auditResult: {
				total: 0,
				success: 0,
				fail: 0,
				list: [],
			},
			isAllot: 0,
		};
	},
	computed: {
		...mapGetters(['isAllDataView', 'isBoss']),
		zsName() {
			return zsRoleType.name;
		},
		authorityId() {
			return this.$route.query.authority_id;
		},
		platformId() {
			return this.$route.query.platform_id;
		},
		showDisFrom() {
			return this.$auth.hasPermi('system:myActivities:distributeGoods');
		},
	},
	methods: {
		show(params, contnet, isBatch) {
			this.params = params;
			this.contnet = contnet;
			this.isBatch = isBatch;
			this.visible = true;
		},
		auditDataUtil() {
			const { showDisFrom, platformId } = this;

			let paramsDy = {};
			let paramsKs = {};
			let apiMap = {
				1: dyActivityAuditBatch,
				2: ksActivityBatchAudit,
			};
			if (this.isBatch) {
				paramsDy = { productInfos: [], auditStatus: 0, isAllot: this.showDisFrom ? 1 : 0 };
				paramsKs = { productInfos: [], auditStatus: 2, isAllot: this.showDisFrom ? 1 : 0 };
				this.params.forEach(item => {
					paramsDy.productInfos.push({
						productId: item.product_id,
						thirdProductId: item.third_product_id,
						authorityId: this.authorityId,
						activityId: item.activity_id,
					});
					paramsKs.productInfos.push({
						productId: item.product_id,
						thirdProductId: item.third_product_id,
						authorityId: this.authorityId,
						activityId: item.activity_id,
					});
				});
			} else {
				let { activity_id, third_activity_id, apply_id, third_product_ids, product_id } = this.params[0];
				apiMap = {
					1: auditActivity,
					2: ksActivityAudit,
				};
				paramsDy = {
					activity_id,
					apply_ids: apply_id,
					third_product_id: third_product_ids,
					product_id,
					authority_id: this.authorityId,
					operation: '0',
					is_allot: this.showDisFrom ? 1 : 0,
				};
				paramsKs = {
					third_activity_id,
					third_product_ids,
					audit_status: 2,
					is_claim: 1,
					authority_id: this.authorityId,
					product_id,
					is_allot: this.showDisFrom ? 1 : 0,
				};
			}
			if (showDisFrom && this.disFrom.user_id) {
				if (this.isBatch) {
					paramsKs.userId = this.disFrom.user_id;
					paramsDy.userId = this.disFrom.user_id;
				} else {
					paramsKs.user_id = this.disFrom.user_id;
					paramsDy.user_id = this.disFrom.user_id;
				}
			}
			let paramsMap = {
				1: paramsDy,
				2: paramsKs,
			};
			return apiMap[platformId](paramsMap[platformId]);
		},

		async confirm() {
			const submitfn = async () => {
				try {
					this.visible = false;
					this.$refs.loadingDialogRef.show();
					const { code, data } = await this.auditDataUtil();
					if (this.isBatch) {
						if (code !== 0) return this.$refs.loadingDialogRef.pureClose();
						const { successNum, failNum, list } = data;
						this.auditResult = {
							total: this.params.length,
							success: successNum,
							fail: failNum,
							list,
						};
						this.$refs.loadingDialogRef.close();
					} else {
						this.$refs.loadingDialogRef.pureClose();
						if (code !== 0) return;
						let msg = '操作成功';
						this.$message.success(msg);
					}
					this.$emit('refreshList');
				} catch (error) {
					if (this.isBatch) {
						this.$refs.loadingDialogRef.pureClose();
					}
				}
			};
			submitfn();
		},
		handleClose() {
			if (!this.showDisFrom) return;
			this.disFrom = {
				user_id: '',
			};
			this.$refs.disFrom.resetFields();
		},
		handleLoadingClose() {
			this.$refs.auditResultDialogRef.show();
		},
	},
};
</script>
 <style lang="less" scoped>
.warn_img {
	width: 16px;
	height: 16px;
	margin-bottom: 2px;
	margin-right: 6px;
}
</style>